import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefOBGyExaminationUterusMeasurementDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationUterusMeasurement/GetDetail?` + params, null);

export const GetRefOBGyExaminationUterusMeasurementList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationUterusMeasurement/GetList?` + params, null);

export const CreateRefOBGyExaminationUterusMeasurement = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationUterusMeasurement/Create`, data);

export const UpdateRefOBGyExaminationUterusMeasurement = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationUterusMeasurement/Update`, data);

export const DeleteRefOBGyExaminationUterusMeasurement = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationUterusMeasurement/Delete`, data);